interface AuthPayload {
  id_token: string
  access_token: string
  refresh_token: string
  userInfo: Record<string, any>
}

interface LoginCodePayload {
  code: string | null
  codeVerifier: string | null
}

const state = {
  idToken: null as string | null,
  accessToken: null as string | null,
  refreshToken: null as string | null,
  userInfo: null as Record<string, any> | null,
}

export function usePropertyUserStore() {
  function restore() {
    const raw = localStorage.getItem('user_auth_property')
    if (!raw) return
    try {
      const parsed = JSON.parse(raw)
      state.accessToken = parsed.accessToken || null
      state.refreshToken = parsed.refreshToken || null
      state.userInfo = parsed.userInfo || null
      state.idToken = parsed.idToken || null
    } catch (e) {
      console.warn('Failed to parse user_auth_admin:', e)
    }
  }

  async function loginByCode(payload: LoginCodePayload) {
    const {
      public: { API_URL, API_BASE_PATH }
    } = useRuntimeConfig()

    const data = await $fetch<AuthPayload>(`${API_URL}/${API_BASE_PATH}/login`, {
      method: 'POST',
      params: {
        code: payload.code,
        code_verifier: payload.codeVerifier,
      },
    })

    setAuth(data)
  }

  async function refreshAccessToken(): Promise<string> {
    const {
      public: { API_URL, API_BASE_PATH }
    } = useRuntimeConfig()

    const data = await $fetch<AuthPayload>(`${API_URL}/${API_BASE_PATH}/refresh-token`, {
      method: 'POST',
      params: {
        refreshToken: state.refreshToken,
      },
    })

    setAuth(data)
    return data.access_token
  }

  function setAuth(auth: AuthPayload) {
    state.accessToken = auth.access_token
    state.refreshToken = auth.refresh_token
    state.userInfo = auth.userInfo
    state.idToken = auth.id_token

    localStorage.setItem(
      'user_auth_property',
      JSON.stringify({
        accessToken: auth.access_token,
        refreshToken: auth.refresh_token,
        userInfo: auth.userInfo,
        idToken: auth.id_token
      })
    )
  }

  async function logout() {
   const {
      public: { API_URL, API_BASE_PATH }
    } = useRuntimeConfig()

    const data = await $fetch(`${API_URL}/${API_BASE_PATH}/logout`, {
      method: 'POST',
      params: {
        idToken: state.idToken
      },
    })
    localStorage.removeItem('user_auth_property');
    localStorage.removeItem('PROPERTY_ID');
    // window.location.href = '/property-manager/login'; 
    window.location.href = data.logoutUrl;
    //handleLogout(data.logoutUrl, '/property-manager/login')
  }

  return {
     get isAuthenticated() {
      if(!localStorage.getItem('user_auth_property')) return false;
      return !!state.accessToken
    },
    get userName() {
      return state.userInfo?.name || ''
    },
    get role() {
      return state.userInfo?.role || null
    },
    get idToken() {
      return state.idToken
    },
    get accessToken() {
      return state.accessToken
    },
    get refreshToken() {
      return state.refreshToken
    },
    get userInfo() {
      return state.userInfo
    },
    restore,
    loginByCode,
    refreshAccessToken,
    logout,
  }
}
